import styles from "./NewsSection.module.scss";
import React from "react";
import { useLazyLoadContentfulEntries } from "source/contentful/provider";
import {
  ContentfulContentType,
  PressRelease,
} from "@tiicker/util/lib/contentful/types";
import NewsCard from "./NewsCard";
import Button from "components/core/Button/Button";

type Props = {
  excludedNewsIds: string[];
};

const NewsSection = (props: Props) => {
  const [newsQuery, newsLoadingInfo] =
    useLazyLoadContentfulEntries<PressRelease>(
      ContentfulContentType.PressRelease,
      {
        groupSize: 6,
        orderBy: "-fields.publishedDate,-sys.createdAt",
        query: {
          content_type: ContentfulContentType.PressRelease,
          "fields.publicationType": "News",
          "sys.id[nin]": props.excludedNewsIds.join(","),
        },
      }
    );

  const loadMore = () => {
    newsLoadingInfo.loadNextGroup();
  };

  return (
    <>
      <div className={styles.container}>
        <div className={styles.news}>
          {newsQuery.state === "DONE" &&
            newsQuery.result.items?.map((n) => (
              <NewsCard
                title={n.fields.title}
                slug={n.fields.slug}
                date={n.fields.publishedDate}
                className={styles.card}
                publicationName={n.fields.publicationName}
              />
            ))}
        </div>
        {newsLoadingInfo.totalCount !==
          (newsQuery.state === "DONE" ? newsQuery.result.items.length : -1) && (
          <Button onClick={loadMore} type="secondary" className={styles.button}>
            Load More
          </Button>
        )}
      </div>
    </>
  );
};

export default NewsSection;
